import React, { Fragment, useEffect, useState } from "react";
import {
 Row,
 Col,
 Card,
 Table,
 Form,
} from "react-bootstrap";
import PageTitle from "../../layouts/PageTitle";
import api from "../../../api";
import { useLocation } from "react-router-dom";

const Reconciliation = () => {

 const location = useLocation();
const [exporting, setExporting] = useState(false);
const [exportingPdf, setExportingPdf] = useState(false);
 const [projects, setProjects] = useState([]);
 const [workOrders, setWorkOrders] = useState([]);
 const [projectId, setProjectId] = useState("");
 const [workOrderId, setWorkOrderId] = useState("");
 const [fromDate, setFromDate] = useState("");
 const [toDate, setToDate] = useState("");

 const [data, setData] = useState([]);
 const [loading, setLoading] = useState(false);

 const [pagination, setPagination] = useState({
 currentPage: 1,
 totalPages: 1,
 totalCount: 0,
 limit: 10,
 hasNext: false,
 hasPrev: false,
 });
const handleExport = async () => {
 if (!workOrderId) return;

 try {
 setExporting(true);

 const params = new URLSearchParams();
 if (projectId) params.set("projectId", projectId);
 if (workOrderId) params.set("workOrderId", workOrderId);
 if (fromDate) params.set("fromDate", fromDate);
 if (toDate) params.set("toDate", toDate);

 const res = await api.get(
 `/reconciliation/export?${params.toString()}`,
 { responseType: "blob" }
 );

 const url = window.URL.createObjectURL(
 new Blob([res.data])
 );

 const link = document.createElement("a");
 link.href = url;
 link.download = "MRS-Reconciliation.xlsx";
 link.click();

 } catch (err) {
 console.error(err);
 alert("Export failed");
 } finally {
 setExporting(false);
 }
};

const handleExportPdf = async () => {
 if (!workOrderId) return;

 try {
 setExportingPdf(true);

 const params = new URLSearchParams();
 if (projectId) params.set("projectId", projectId);
 if (workOrderId) params.set("workOrderId", workOrderId);
 if (fromDate) params.set("fromDate", fromDate);
 if (toDate) params.set("toDate", toDate);

 const res = await api.get(
 `/reconciliation/export-pdf?${params.toString()}`,
 { responseType: "blob" }
 );

 const url = window.URL.createObjectURL(
 new Blob([res.data], { type: "application/pdf" })
 );

 const link = document.createElement("a");
 link.href = url;
 link.download = `MRS-Reconciliation-${workOrderId}.pdf`;
 link.click();

 } catch (err) {
 console.error(err);
 alert("PDF Export failed");
 } finally {
 setExportingPdf(false);
 }
};

 /* ================= LOAD FROM URL ================= */
 useEffect(() => {
 const params = new URLSearchParams(location.search);

 const project = params.get("project");
 const wo = params.get("workOrder");

 if (project) setProjectId(project);
 if (wo) setWorkOrderId(wo);
 }, [location.search]);

 /* ================= LOAD PROJECTS ================= */
 useEffect(() => {
 api.get("/projects").then((res) => {
 if (res.data.success) setProjects(res.data.data);
 });
 }, []);

  /* ================= LOAD WORK ORDERS ================= */
  useEffect(() => {
    if (projectId) {
      api
        .get(`/reconciliation/by-project/${projectId}`)
        .then((res) => {
          if (res.data.success) setWorkOrders(res.data.data || []);
        });
    } else {
      api
        .get("/work-orders?limit=1000")
        .then((res) => {
          if (res.data.success) setWorkOrders(res.data.data || []);
        });
    }
  }, [projectId]);

  const handleProjectFilter = (pId) => {
    setProjectId(pId);
    if (pId && workOrderId) {
      const currentWo = workOrders.find((w) => String(w._id) === String(workOrderId));
      const currentWoProjId = currentWo?.project?._id || currentWo?.project;
      if (currentWoProjId && String(currentWoProjId) !== String(pId)) {
        setWorkOrderId("");
        setData([]);
      }
    } else if (!pId) {
      setWorkOrderId("");
      setData([]);
    }
  };

  const handleWorkOrderFilter = (woId) => {
    setWorkOrderId(woId);
    if (woId) {
      const selectedWo = workOrders.find((w) => String(w._id) === String(woId));
      const autoProjId = selectedWo?.project?._id || selectedWo?.project;
      if (autoProjId) {
        setProjectId(String(autoProjId));
      }
    }
    setPagination((prev) => ({ ...prev, currentPage: 1 }));
  };
 const fetchData = async () => {
 if (!workOrderId) return;

 try {
 setLoading(true);

 const res = await api.get(
 `/reconciliation/mrs?projectId=${projectId}&workOrderId=${workOrderId}&fromDate=${fromDate}&toDate=${toDate}&page=${pagination.currentPage}&limit=${pagination.limit}`
 );

 if (res.data.success) {
 setData(res.data.data || []);

 if (res.data.pagination) {
 setPagination((prev) => ({
 ...prev,
 ...res.data.pagination,
 }));
 }
 }

 } finally {
 setLoading(false);
 }
 };

 useEffect(() => {
 fetchData();
 }, [workOrderId, fromDate, toDate, pagination.currentPage]);

 return (
 <Fragment>
 <PageTitle activeMenu="Reconciliation" motherMenu="Commercial" />

 <Row>
 <Col lg={12}>
 <Card>
 <Card.Header className="d-flex justify-content-between align-items-center">
 <Card.Title className="mb-0">
 Material Reconciliation
 </Card.Title>

 <div className="d-flex gap-2">
 <button
 className="btn btn-success btn-sm"
 onClick={handleExport}
 disabled={!workOrderId || exporting}
 >
 {exporting ? (
 <>
 <span className="spinner-border spinner-border-sm me-2"></span>
 Exporting...
 </>
 ) : (
 <>
 <i className="fas fa-file-excel me-2"></i>
 Excel
 </>
 )}
 </button>

 <button
 className="btn btn-danger btn-sm"
 onClick={handleExportPdf}
 disabled={!workOrderId || exportingPdf}
 >
 {exportingPdf ? (
 <>
 <span className="spinner-border spinner-border-sm me-2"></span>
 Exporting...
 </>
 ) : (
 <>
 <i className="fas fa-file-pdf me-2"></i>
 PDF
 </>
 )}
 </button>
 </div>
</Card.Header>

 <Card.Body>

 {/* ================= FILTERS ================= */}
 <Row className="mb-3">
 <Col md={4}>
 <Form.Select
 value={projectId}
 onChange={(e) => {
 setProjectId(e.target.value);
 setWorkOrderId("");
 setData([]);
 }}
 >
 <option value="">Select Project</option>
 {projects.map((p) => (
 <option key={p._id} value={p._id}>
 {p.projectName}
 </option>
 ))}
 </Form.Select>
 </Col>

 <Col md={4}>
 <Form.Select
 value={workOrderId}
 onChange={(e) => {
 setWorkOrderId(e.target.value);
 setPagination((prev) => ({ ...prev, currentPage: 1 }));
}}
 disabled={!projectId}
 >
 <option value="">Select Work Order</option>
              {workOrders.map((w) => (
                <option key={w._id} value={w._id}>
                  {w.woNo}{w.label ? ` – ${w.label}` : ""}{!projectId && (w.project?.projectName || w.project?.name) ? ` (${w.project.projectName || w.project.name})` : ""}
                </option>
              ))}
 </Form.Select>
 </Col>

 <Col md={2}>
 <Form.Control
 type="date"
 value={fromDate}
 onChange={(e) => {
 setFromDate(e.target.value);
 if (toDate && e.target.value && toDate < e.target.value) {
 setToDate("");
 }
 setPagination((prev) => ({ ...prev, currentPage: 1 }));
 }}
 placeholder="From Date"
 />
 </Col>

 <Col md={2}>
 <Form.Control
 type="date"
 value={toDate}
 min={fromDate || undefined}
 onChange={(e) => {
 setToDate(e.target.value);
 setPagination((prev) => ({ ...prev, currentPage: 1 }));
 }}
 placeholder="To Date"
 />
 </Col>
 </Row>

 {/* ================= TABLE ================= */}
 {loading ? (
 <div className="text-center py-5">
 <div className="spinner-border text-primary"></div>
 <p className="mt-3">Loading reconciliation...</p>
 </div>
 ) : data.length === 0 ? (
 <div className="text-center py-5">
 <p>No data found.</p>
 </div>
 ) : (
 <Table bordered hover responsive size="sm">
 <thead>
 <tr>
 <th>#</th>
 <th>WLINO</th>
 <th>HSN/SAC</th>
 <th>Item</th>
 <th>WO Qty</th>
 <th>UOM</th>
 <th>Supply</th>
 <th>Installed</th>
 <th>Wastage</th>
 <th>Balance</th>
 <th>Delivery No</th>
 <th>MIR No</th>
 <th>JMR No</th>
 </tr>
 </thead>

 <tbody>
 {data.map((row, i) => (
 <tr key={i}>
 <td>
 {(pagination.currentPage - 1) *
 pagination.limit +
 (i + 1)}
 </td>

 <td>{row.wlino || "-"}</td>

 <td>{row.hsnSac || "-"}</td>

 <td>{row.itemName}</td>

 <td>{row.woQty}</td>

 <td>{row.uom}</td>

 <td>{row.supplyQty}</td>

 <td>{row.installedQty}</td>

 <td>{row.wastage}</td>

 <td
 className={
 row.balance < 0
 ? "text-danger fw-bold"
 : "text-success fw-bold"
 }
 >
 {row.balance}
 </td>

 <td>
 {row.deliveryNos?.length ? (
 row.deliveryNos.map((n, idx) => (
 <div key={idx}>{n}</div>
 ))
 ) : (
 "-"
 )}
 </td>

 <td>
 {row.mirNos?.length ? (
 row.mirNos.map((n, idx) => (
 <div key={idx}>{n}</div>
 ))
 ) : (
 "-"
 )}
 </td>

 <td>
 {row.jmrNos?.length ? (
 row.jmrNos.map((n, idx) => (
 <div key={idx}>{n}</div>
 ))
 ) : (
 "-"
 )}
 </td>
 </tr>
 ))}
 </tbody>
 </Table>
 )}

 {/* ================= PAGINATION ================= */}
 {pagination.totalPages > 1 && (
 <div className="d-flex justify-content-between mt-3">
 <div>
 Showing{" "}
 {(pagination.currentPage - 1) * pagination.limit + 1}
 {" — "}
 {Math.min(
 pagination.currentPage * pagination.limit,
 pagination.totalCount
 )}
 {" of "}
 {pagination.totalCount}
 </div>

 <nav>
 <ul className="pagination mb-0">

 {/* Prev */}
 <li
 className={`page-item ${
 !pagination.hasPrev ? "disabled" : ""
 }`}
 >
 <button
 className="page-link"
 onClick={() =>
 setPagination((prev) => ({
 ...prev,
 currentPage: prev.currentPage - 1,
 }))
 }
 >
 Previous
 </button>
 </li>

 {/* Page Numbers */}
 {[...Array(pagination.totalPages)].map((_, idx) => (
 <li
 key={idx}
 className={`page-item ${
 pagination.currentPage === idx + 1
 ? "active"
 : ""
 }`}
 >
 <button
 className="page-link"
 onClick={() =>
 setPagination((prev) => ({
 ...prev,
 currentPage: idx + 1,
 }))
 }
 >
 {idx + 1}
 </button>
 </li>
 ))}

 {/* Next */}
 <li
 className={`page-item ${
 !pagination.hasNext ? "disabled" : ""
 }`}
 >
 <button
 className="page-link"
 onClick={() =>
 setPagination((prev) => ({
 ...prev,
 currentPage: prev.currentPage + 1,
 }))
 }
 >
 Next
 </button>
 </li>

 </ul>
 </nav>
 </div>
 )}

 </Card.Body>
 </Card>
 </Col>
 </Row>
 </Fragment>
 );
};

export default Reconciliation;
